import { Result, Round, Team } from '@vote4dance/judging-schema';
import { AcroId, HeatsTeamId, JudgeId, RoundId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";
import { RoundState } from '@vote4dance/judging-schema';
import { RoundItem } from './rounds';

export type ResultItem = Result
& Pick<Team, 'team_name_1' | 'team_name_2' | 'team_name_3' | 'team_start_number' | 'team_start_order' | 'team_id' | 'team_show_name' >
& {
    acro_id: AcroId,
    heat_number?: number
}

export type PointResultItem = ResultItem
& Pick<Round, 'class_id' | 'round_label' | 'round_status' | 'round_num_through' | 'round_parent_id' | 'round_type' >
& {
    heats_team_target_id: string,
    heats_team_placement: string
}

export type GroupResultItem = Result
& {
    heats_team_placement?: number
}

export type RoundStateItem = RoundState & RoundItem;

type ResultItemCompanion = {
    getPartial(result: ResultItem, defaults?: any): any;
}

export const ResultItem: ResultItemCompanion = {
    getPartial(result: ResultItem, defaults?: any): any {
        const partial = Object.assign(defaults, JSON.parse(result.result_partial!));
        return partial ? partial : {};
    }
}

export function HeatsTeamResultSource(heats_team_id: HeatsTeamId) {
    return new StreamSource<ResultItem[]>(`/teamresults/${heats_team_id}`);
}

export function RoundResultSource(round_id: RoundId) {
    return new StreamSource<ResultItem[]>(`/roundresults/${round_id}`);
}

export function RoundTeamResultSource(round_id: RoundId, judge_id: JudgeId) {
    return new StreamSource<ResultItem[]>(`/roundteamresults/${round_id}/${judge_id}`);
}

export function RoundStateSource(round_id: RoundId) {
    return new StreamSource<RoundStateItem[]>(`/roundstates/${round_id}`);
}

export function RoundPartialResultSource(round_id: RoundId) {
    return new StreamSource<ResultItem[]>(`/roundpartialresults/${round_id}`);
}

export function GroupTeamResultSource(round_id: RoundId, heats_team_id: HeatsTeamId) {
    return new StreamSource<GroupResultItem[]>(`/groupteamresults/${round_id}/${heats_team_id}`);
}

export function RoundResultCommentSource(round_id: RoundId) {
    return new StreamSource<ResultItem[]>(`/roundresultcomments/${round_id}`);
}